import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Button } from '@mui/material'

import { NewUserStep1, UserSalutationType, useUserSalutationTypeOptions } from '~api/models'
import { getUser } from '~store/account/selectors'
import FormTextField from '~shared/components/reactHookForm/input/FormTextField'
import Row from '~shared/components/MuiGrid/Row'
import Col from '~shared/components/MuiGrid/Col'
import FormAutocomplete from '~shared/components/reactHookForm/input/FormAutocomplete/FormAutocomplete'
import { useAutocompleteName } from '~utils/autocompleteType'
import { editProfile } from '~utils/msal/msalAuthentication'

const Step1Form: React.FC = () => {
  const { t } = useTranslation()
  const acName = useAutocompleteName<NewUserStep1>()
  const user = useSelector(getUser)
  const userSalutation = useUserSalutationTypeOptions()

  return <>
    <Row spacingTop={3}>
      <Col>
        <p>{t('form:newUserFormStep1Notification')}</p>
      </Col>
    </Row>

    <Row>
      <Col>
        <FormAutocomplete
          label={t('common:salutation')}
          name={acName('salutation')}
          options={userSalutation}
          disabled={!!user?.salutation}
          defaultValue={user?.salutation ? UserSalutationType[user.salutation] : undefined}
        />
      </Col>
    </Row>
    <Row>
      <Col>
        <FormTextField
          label={t('common:firstName')}
          name={acName('firstName')}
          disabled={!!user?.firstName}
          defaultValue={user?.firstName}
        />
      </Col>
      <Col>
        <FormTextField
          label={t('common:surname')}
          name={acName('lastName')}
          disabled={!!user?.lastName}
          defaultValue={user?.lastName}
        />
      </Col>
    </Row>
    <Row>
      <Col>
        <FormTextField
          label={t('common:eMail')}
          name={acName('email')}
          disabled={!!user?.email}
          defaultValue={user?.email}
        />
      </Col>
    </Row>

    <Row spacingBottom={3}>
      <Col>
        <Button
          variant='outlined'
          color='secondary'
          onClick={editProfile}
        >
          {t('common:editAzureProfile')}
        </Button>
      </Col>
    </Row>
  </>
}

export default Step1Form
